"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultKonfektionierungArtNr = exports.KonfektionierungTyp = void 0;
var KonfektionierungTyp;
(function (KonfektionierungTyp) {
    /** For a `Konfektionierung` which combines more than 1 position */
    KonfektionierungTyp["combined"] = "combined";
    /** Package a `Kette` at a `Trommel` */
    KonfektionierungTyp["auftrommelnRatePerMeter"] = "auftrommelnRatePerMeter";
    /** Mount the `Trommel` at a transport device. */
    KonfektionierungTyp["auftrommelnTransportgestellAnschrauben"] = "auftrommelnTransportgestellAnschrauben";
    KonfektionierungTyp["befestigungZugentlastungFactor"] = "befestigungZugentlastungFactor";
    KonfektionierungTyp["BeschriftungLeitungFactorLessThan_4"] = "BeschriftungLeitungFactorLessThan_4";
    KonfektionierungTyp["BeschriftungLeitungFactorMoreThan_3"] = "BeschriftungLeitungFactorMoreThan_3";
    KonfektionierungTyp["leitungEinlegenMeterFactorChainClosed"] = "leitungEinlegenMeterFactorChainClosed";
    KonfektionierungTyp["leitungEinlegenMeterFactorChainWithFachboeden"] = "leitungEinlegenMeterFactorChainWithFachboeden";
    KonfektionierungTyp["leitungEinlegenMeterFactorChainWithTrennstegen"] = "leitungEinlegenMeterFactorChainWithTrennstegen";
    KonfektionierungTyp["leitungEinlegenMeterFactorDefault"] = "leitungEinlegenMeterFactorDefault";
    KonfektionierungTyp["paletteRatePerMeter"] = "paletteRatePerMeter";
    KonfektionierungTyp["schliessenOeffnungsstegFactorKette"] = "schliessenOeffnungsstegFactorKette";
    KonfektionierungTyp["schliessenOeffnungsstegFactorRohr"] = "schliessenOeffnungsstegFactorRohr";
    KonfektionierungTyp["verpackungMaterialPalette"] = "verpackungMaterialPalette";
    KonfektionierungTyp["verpackungMaterialTrommel"] = "verpackungMaterialTrommel";
    KonfektionierungTyp["verpackungPaletteOver900"] = "verpackungPaletteOver900";
    KonfektionierungTyp["verpackungPaletteUnder901"] = "verpackungPaletteUnder901";
    KonfektionierungTyp["verpackungTrommelGreater1500"] = "verpackungTrommelGreater1500";
    KonfektionierungTyp["verpackungTrommelUnder1501"] = "verpackungTrommelUnder1501";
})(KonfektionierungTyp = exports.KonfektionierungTyp || (exports.KonfektionierungTyp = {}));
exports.defaultKonfektionierungArtNr = 'KONFEKTIONIERUNG';
//# sourceMappingURL=KonfektionierungModel.js.map